import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVerifiedUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.9497 15.1792L16.1035 10.0005L15.1842 9.08122L10.9497 13.341L8.80546 11.1967L7.88621 12.116L10.9497 15.1792ZM11.9997 21.0812C9.90354 20.5247 8.16287 19.3071 6.77771 17.4285C5.39237 15.5496 4.69971 13.4486 4.69971 11.1255V5.74672L11.9997 2.93896L19.2997 5.74672V11.1255C19.2997 13.4486 18.607 15.5496 17.2217 17.4285C15.8365 19.3071 14.0959 20.5247 11.9997 21.0812ZM11.9997 19.7255C13.733 19.188 15.1664 18.113 16.2997 16.5005C17.433 14.888 17.9997 13.0963 17.9997 11.1255V6.62547L11.9997 4.33497L5.99971 6.62547V11.1255C5.99971 13.0963 6.56637 14.888 7.69971 16.5005C8.83304 18.113 10.2664 19.188 11.9997 19.7255Z",
		fill: "currentColor"
	})
});
export default SvgVerifiedUser;
